export default {
  ALLIANZ_INVESTMENT_PRODUCT_FUND_TYPE_REPOSITORY: Symbol.for('ALLIANZ_INVESTMENT_PRODUCT_FUND_TYPE_REPOSITORY'),
  SEARCH_INVESTMENT_PRODUCT_FUND_TYPE_BY_CUSTOMER_QUERY: Symbol.for('SEARCH_INVESTMENT_PRODUCT_FUND_TYPE_BY_CUSTOMER_QUERY'),
};
